import React from "react";

export function RightRectangleIcon() {
    return <svg width="17" height="28" viewBox="0 0 17 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.14583 27.3166C3.19742 28.2278 1.65973 28.2278 0.711311 27.3166C-0.173878 26.4661 -0.232887 25.1224 0.534275 24.2062L0.711311 24.0168L11.137 14L0.711311 3.98325C-0.173878 3.13277 -0.232887 1.78911 0.534275 0.872875L0.711311 0.683418C1.5965 -0.167057 2.99501 -0.223755 3.94864 0.513323L4.14583 0.683418L16.2887 12.3501C17.1739 13.2006 17.2329 14.5442 16.4657 15.4605L16.2887 15.6499L4.14583 27.3166Z" fill="#3EC1CB"/>
    </svg>;
}
